export default __webpack_public_path__ + "static/media/ua.b36690cd.svg";